"use client";

import { c as _c } from "react/compiler-runtime";
import Modal from ".";
import { ModalProps } from "@/shared/types/interface/modal";
import { TERMS } from "@/shared/constants/terms";
import { TermModalType } from "@/shared/types/type/terms";
interface TermModalProps extends ModalProps {
  term: TermModalType;
  termTitle: string;
}
const TermModal = t0 => {
  const $ = _c(7);
  const {
    open,
    onClose,
    term,
    termTitle
  } = t0;
  const t1 = TERMS[term as keyof typeof TERMS];
  let t2;
  if ($[0] !== t1 || $[1] !== termTitle) {
    t2 = <div className="h-[calc(100vh-100px)]"><iframe src={t1} width="100%" height="100%" title={termTitle} className="border-0" /></div>;
    $[0] = t1;
    $[1] = termTitle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClose || $[4] !== open || $[5] !== t2) {
    t3 = <Modal open={open} onClose={onClose} titlePosition="center">{t2}</Modal>;
    $[3] = onClose;
    $[4] = open;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default TermModal;